(() => {
  const config = window.MomentePersonalization;
  if (!config) return;
  const forms = () => [...document.querySelectorAll('form[action$="/cart/add"]')].filter(form => !form.hasAttribute('data-momente-native-editor') && form.querySelector('[name="product-id"]')?.value === String(config.productId));
  const designInput = form => form.querySelector('[name="properties[Personalization ID]"]');
  let pending = false;
  function update() {
    pending = false;
    for (const form of forms()) {
      const ready = Boolean(designInput(form)?.value.trim());
      for (const button of form.querySelectorAll('button[type="submit"],input[type="submit"]')) {
        if (!ready) {
          if (!button.disabled) {
            button.dataset.momenteDesignDisabled = 'true';
            button.disabled = true;
          }
          if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        } else if (button.dataset.momenteDesignDisabled === 'true') {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          delete button.dataset.momenteDesignDisabled;
        }
      }
      let status = form.querySelector('[data-momente-design-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.momenteDesignStatus = '';
        status.setAttribute('role', 'status');
        status.style.cssText = 'font-size:.9rem;line-height:1.5;margin:0 0 12px;width:100%';
        form.prepend(status);
      }
      const message = ready ? config.readyMessage : config.requiredMessage;
      if (status.textContent !== message) status.textContent = message;
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  document.addEventListener('submit', event => {
    if (!forms().includes(event.target) || designInput(event.target)?.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    update();
    document.querySelector('button[id^="personalize-button-"]')?.focus();
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.closest('variant-picker') || !event.target.matches('select,input')) return;
    const form = forms()[0];
    if (!form || !designInput(form)?.value.trim()) return;
    const removeButton = document.querySelector('button[id^="personalize-button-"]');
    if (removeButton) removeButton.click();
    for (const form of forms()) designInput(form)?.remove();
    schedule();
  }, true);
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled']});
  document.addEventListener('input', schedule);
  document.addEventListener('variant:update', schedule);
  update();
})();

